import styled, { css } from 'styled-components';
// Images
import ServerSideError from '../../../../images/ServerSideError.svg';
import ServerSideErrorMobile from '../../../../images/ServerSideErrorMobile.svg';

// Utils
import { media } from '../../../../utils/device';

const sharedStyle = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 60px 0px 0px 0px;
  background: #ffffff;
  height: 400px;
  width: 700px;
  font-size: 32px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px 10px 60px 10px;
  padding: 45px 0px 32px 0px;

  ${media.desktop} {
    height: 400px;
    width: 700px;
    font-size: 27px;
    margin: 35px 0px 35px 0px;
  }

  ${media.tabletS} {
    height: 380px;
    width: 500px;
    font-size: 24px;
    margin: 30px 0px 0px 0px;
  }

  ${media.mobileL} {
    height: 400px;
    width: 350px;
    font-size: 19px;
    margin: 60px 0px 0px 0px;
  }

  ${media.mobileM} {
    height: 380px;
    width: 300px;
    font-size: 15px;
    margin: 30px 0px 0px 0px;
  }

  ${media.mobileS} {
    height: 380px;
    width: 270px;
    font-size: 14px;
    margin: 30px 0px 0px 0px;
  }
`;

export const FormWrapperStyles = styled.div`
  ${sharedStyle}
`;

export const ErrorFormWrapperStyles = styled.div`
  ${sharedStyle}
  flex-direction: row;
  align-items: flex-start;
  background-image: url('${ServerSideError}');

  ${media.tabletS} {
    background-repeat: no-repeat;
    background-size: 800px;
    background-position: bottom;
  }

  ${media.mobileL} {
    background-image: url('${ServerSideErrorMobile}');
    background-repeat: no-repeat;
    background-size: 300px;
    background-position: bottom;
    background-origin: content-box;
  }

  ${media.mobileM} {
    background-image: url('${ServerSideErrorMobile}');
    background-repeat: no-repeat;
    background-size: 250px;
    background-position: bottom;
    background-origin: content-box;
  }

  ${media.mobileS} {
    font-size: 22px;
    background-image: url('${ServerSideErrorMobile}');
    background-repeat: no-repeat;
    background-size: 210px;
    background-position: bottom;
    background-origin: content-box;
  }
`;

export const ServerErrorMessageStyles = styled.div`
  font-size: 22px;
  width: 300px;

  ${media.tabletS} {
    font-size: 16px;
    width: 230px;
  }

  ${media.mobileL} {
    font-size: 16px;
    width: 270px;
  }

  ${media.mobileM} {
    font-size: 16px;
    width: 220px;
  }

  ${media.mobileS} {
    font-size: 16px;
    width: 200px;
  }
`;

export const ServerErrorCodeStyles = styled.div`
  font-size: 40px;

  ${media.tabletS} {
    font-size: 30px;
  }

  ${media.mobileL} {
    font-size: 27px;
  }

  ${media.mobileM} {
    font-size: 30px;
  }

  ${media.mobileS} {
    font-size: 30px;
  }
`;

export const ErrorMessageStyles = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #ff0000;
`;

export const ErrorWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
`;

interface SpacerProps {
  height: string;
  width: string;
}

export const SpacerStyles = styled.span`
  width: ${(props: SpacerProps) => props.width}px;
  min-width: ${(props: SpacerProps) => props.width}px;
  height: ${(props: SpacerProps) => props.height}px;
  min-height: ${(props: SpacerProps) => props.height}px;
`;

export const HelperTextStyles = styled.div`
  font-size: 14px;
  text-align: center;
  color: #787a7a;

  ${media.mobileS} {
    font-size: 12px;
  }
`;

export const ThankYouSmallTextStyles = styled.div`
  font-size: 20px;
  text-align: center;
  color: #787a7a;

  ${media.mobileS} {
    font-size: 12px;
  }

  ${media.mobileL} {
    font-size: 14px;
  }
`;

export const SubmittedDataWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SubmittedDataHeaderStyles = styled.div`
  display: flex;
  align-items: center;

  ${media.tabletS} {
    font-size: 22px;
  }

  ${media.mobileL} {
    font-size: 16px;
  }

  ${media.mobileM} {
    font-size: 14px;
  }

  ${media.mobileS} {
    font-size: 12px;
  }
`;
